import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, CalendarIcon, ClipboardListIcon, CheckCircle2Icon, WrenchIcon } from 'lucide-react';
import { SITE } from '../constants/site';
const STEPS = [{
  icon: PhoneIcon,
  title: 'You call or text',
  desc: `Reach us at ${SITE.phone}.`
}, {
  icon: CalendarIcon,
  title: 'We schedule a visit',
  desc: 'A diagnostic visit at your convenience.'
}, {
  icon: ClipboardListIcon,
  title: 'We walk your property',
  desc: 'We identify every issue and give a clear, honest quote.'
}, {
  icon: CheckCircle2Icon,
  title: 'You decide',
  desc: 'No pressure, no obligation.'
}, {
  icon: WrenchIcon,
  title: 'We get to work',
  desc: "We don't leave until the job is done right."
}];
export function OfferSection() {
  return <section className="w-full bg-slate-50 py-16 sm:py-24" data-id="element-240" data-mp="2t59inaxtfelv">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-241" data-mp="2t6ucszg7wvj7">
        <div className="mx-auto max-w-3xl text-center" data-id="element-242" data-mp="2y3umrlg6uifl">
          <span className="text-xs font-bold uppercase tracking-wide text-nfgreen-dark" data-id="element-243" data-mp="2y6gsrgnfkpvp">
            The Offer
          </span>
          <h2 className="mt-3 font-display text-3xl font-extrabold text-slate-900 sm:text-4xl" data-id="element-244" data-mp="xx1wnsceca2w">
            Accepting new residential & commercial clients now
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-245" data-mp="svcl8bl9huea">
            Here's exactly what happens when you call.
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-246" data-mp="1lmw76398tmjz">
          {STEPS.map((step, i) => <motion.div key={step.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="relative rounded-2xl border border-slate-200 bg-white p-6" data-id="element-247" data-mp="1gmrukobghbz1" data-mpi={i}>
              <span className="absolute right-4 top-4 font-display text-3xl font-extrabold text-slate-100" data-id="element-248" data-mp="3sd3uvu96hj05">
                {i + 1}
              </span>
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-nfblue/10 text-nfblue" data-id="element-249" data-mp="3tuiycsebxeme">
                <step.icon className="h-5 w-5" data-id="element-250" data-mp="2mwylauqdwat" />
              </div>
              <h3 className="mt-4 font-display text-base font-bold text-slate-900" data-id="element-251" data-mp="3ks9sifu0a9fc">
                {step.title}
              </h3>
              <p className="mt-1.5 text-sm text-slate-600" data-id="element-252" data-mp="3owzlnwxa59wk">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}